import { render, staticRenderFns } from "./FaixaEtariaCard.vue?vue&type=template&id=fc96e9d2&scoped=true"
import script from "./FaixaEtariaCard.vue?vue&type=script&lang=js"
export * from "./FaixaEtariaCard.vue?vue&type=script&lang=js"
import style0 from "./FaixaEtariaCard.vue?vue&type=style&index=0&id=fc96e9d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc96e9d2",
  null
  
)

export default component.exports